import React, { useCallback, useState } from 'react';
import { FiArrowLeft } from 'react-icons/fi';
import { FaStore, FaMapMarkerAlt, FaCashRegister } from 'react-icons/fa';
import { format } from 'date-fns';
import ptBR from 'date-fns/locale/pt-BR';

import { formatPrice } from '../../../utils/format';

import {
  Container,
  Content,
  Header,
  OrderContent,
  Cliente,
  Order,
  Mesa,
  Items,
  Item,
  Pagamento,
  HorarioAgendado,
  EnderecoEntrega,
  Cupom,
  Total,
} from './styles';

type VendaData = {
  agendamento: boolean;
  campanha: string;
  cupom: { id_desconto: string; type_desc: string; valor: string };
  distance: number;
  duration: number;
  endereco_entrega: EnderecoData;
  formatted_address: string;
  hora_agendada: string;
	cliente: {
		id: string;
		nome: string;
		doc: string;
		phone: string;
		cid: string;
	}
  id_order: number;
  items: ItemData[];
  merchant_id: number;
  mesa: boolean;
  mesa_number: string;
  mesa_token: string;
  order_data: string;
  order_status: string;
  pagamentos: PagamentoData[];
  prev_entrega: string;
  retirar: boolean;
  subTotal: number;
  taxa_entrega: number;
  taxa_service: number;
  tempo_preparo: number;
  tempo_preparo_str: string;
  total: number;
  totalFormatted: string;
  total_merchant: number;
}
type EnderecoData = {
  bai: string;
  cep: string;
  cid: string;
  cidcod: string;
  comp: string;
  distace: {
    distance: { value: number };
    duration: { value: number };
  };
  endereco: string;
  formatted_address: string;
  id: string;
  location: { lat: number; lng: number };
  num: string;
  ponto_ref: string;
  uf: string;
}
type PagamentoData = {
  band_pay: string;
  chave_pay: string;
  currency_pay: string;
  id_pay: number;
  method_pay: string;
  name_pay: string;
  tipchave_pay: string;
  trocoFormatted: string;
  troco_para: number;
  type_pay: string;
  url_pay: string;
}
type ItemData = {
  cod_barras: string;
  complementos: ComplementoData[];
  descricao: string;
  id: string;
  nome: string;
  obs: string;
  promocao: string;
  qtd: number;
  total: number;
  totalFormatted: string;
  url_imagem: string;
  valor: number;
  valorFormatted: string;
}
type ComplementoData = {
  codigo: string;
  descricao: string;
  grupo: string;
  nome: string;
  priceFormatted: string;
  qtd: number;
  qtd_gratis: number;
  qtd_maxima: number;
  valor: number;
}
interface ModalParams {
	id?: string;
	onClose: any;
	isVisible: boolean;
	venda: VendaData;
}

const ModalVenda: React.FC<ModalParams> = ({
  id = 'modalVenda',
  onClose = () => {},
  isVisible,
  venda,
}) => {
  const handleOutSideClick = useCallback(
    (e: any) => {
      if (e.target.id === id) {
        onClose();
      }
    },
    [id, onClose],
  );

  const [visible, setVisible] = useState(isVisible);

  return (
    <Container id="modalVenda" onClick={handleOutSideClick}>
      <Content className={`${visible ? 'active' : ''}`}>
        <Header>
          <button
            onClick={() => {
              setVisible(false);
              setTimeout(() => {
                onClose();
              }, 300);
            }}
          >
            <FiArrowLeft /> Voltar
          </button>
        </Header>

        <OrderContent>
          <Cliente>
            <h1>Cliente</h1>
            <h2>{venda.cliente?.id} - {venda.cliente?.nome}</h2>
            <hr />
          </Cliente>

          <Order status={venda.order_status && venda.order_status.toUpperCase()}>
            <h1>Pedido</h1>
            <h2 className="id-status">
              {venda.id_order} -{' '}
              <span className="status">{venda.order_status}</span>
            </h2>
            <h2>
              <span>Pedido realizado:</span>&nbsp;{venda.order_data}
            </h2>
            <h2>
              <span>Tempo de Preparo:</span>&nbsp;{venda.tempo_preparo_str}
            </h2>
            <h2>
              <span>Previsã de Entrega:</span>&nbsp;
              {!venda.mesa && venda.prev_entrega &&
                format(
                  new Date(venda.prev_entrega),
                  "EEEEEE', dia' dd 'de' MMM 'de' yyyy 'às' HH:mm'h'",
                  { locale: ptBR },
                )}
            </h2>

            <hr />
          </Order>

          {venda.mesa && (
            <Mesa>
              <h1>Mesa</h1>
              <h2>Pedido feito na mesa: {venda.mesa_number}</h2>
              <hr />
            </Mesa>
          )}

					{venda.items && venda.items.length > 0 && (
						<Items>
							<h1>Items</h1>

							{venda.items?.map((item, indice) => (
								<Item key={indice}>
									<div className="qtd-name">
										<div>
											<span>
												{item.qtd}x {item.nome}
											</span>
										</div>

										<div>
											<span>{item.totalFormatted}</span>
										</div>
									</div>

									{item.complementos && item.complementos.length > 0
										? item.complementos.map((comp, indicee) => {
											return comp.qtd > 0 ? (
												<div className="qtd-complemento" key={indicee}>
													<div>
														<span>
															{comp.qtd}x {comp.nome}
														</span>
													</div>
												</div>
											) : null;
										})
										: null}

									<hr />
								</Item>
							))}
						</Items>
					)}

					{venda.pagamentos && venda.pagamentos.length > 0 && (
						<Pagamento>
							<h1>Pagamento</h1>
								{venda.pagamentos?.map(pagamento => {
									return (
										<div className='pag-item' key={pagamento.id_pay}>
											<div className="pag-icon-name">
												<div className="pag-icon">
													{venda.mesa ? (
														<div className="icon">
															<FaCashRegister />
														</div>
													) : (
															<img src={pagamento.url_pay} alt="Pagamento" />
													)}
												</div>

												<div className="pag-name-troco">
													<h2>
														{venda.mesa ? 'Pago no caixa.' : pagamento.name_pay}
													</h2>
												</div>
											</div>

											{pagamento.method_pay === 'CASH' && pagamento.troco_para > 0 && (
												<h3>Troco para {pagamento.trocoFormatted}</h3>
											)}
										</div>
									)
								})}

							<hr />
						</Pagamento>
					)}

          {venda.cupom?.id_desconto && (
            <Cupom>
              <h1>Cupom desconto</h1>
              <h2>Tipo: {venda.cupom.type_desc}</h2>
              <h2>Valor: {venda.cupom.valor}</h2>

              <hr />
            </Cupom>
          )}

          {venda.agendamento && (
            <HorarioAgendado>
              <h1>Hora agendada</h1>

              <h2>{venda.hora_agendada}</h2>
            </HorarioAgendado>
          )}

          <EnderecoEntrega>
            <h1>Endereço de Entrega</h1>

            {venda.retirar ? (
              <div className="end-entrega">
                <div className="icon-end">
                  <div className="icon">
                    <FaStore />
                  </div>

                  <div className="end">
                    <h1>Retirar no local.</h1>
                  </div>
                </div>
              </div>
            ) : (
              <div className="end-entrega">
                <div className="icon-end">
                  <div className="icon">
                    {!venda.mesa ? <FaMapMarkerAlt /> : <FaStore />}
                  </div>

                  <div className="end">
                    {!venda.mesa ? (
                      <>
                        <h1>
                          {venda.endereco_entrega?.endereco},{' '}
                          {venda.endereco_entrega?.num}
                        </h1>
                        <h2>
                          {venda?.endereco_entrega?.comp &&
                            `${venda.endereco_entrega?.comp}, `}{' '}
                          {venda.endereco_entrega?.bai},{' '}
                          {venda.endereco_entrega?.cid} -{' '}
                          {venda.endereco_entrega?.uf}
                        </h2>
                      </>
                    ) : (
                      <h1>Pedido feito na loja.</h1>
                    )}
                  </div>
                </div>
              </div>
            )}

            <hr />
          </EnderecoEntrega>

          <Total>
            <h1>Totais</h1>

            <div className="content">
              <div className="sub-total">
                <div>
                  <span>SubTotal</span>
                </div>

                <div>
                  <span>{formatPrice(venda.subTotal)}</span>
                </div>
              </div>

              <div className="taxa-entrega">
                <div>
                  <span>Taxa de Entrega</span>
                </div>

                <div>
                  <span>{formatPrice(venda.taxa_entrega)}</span>
                </div>
              </div>

              <div className="total">
                <div>
                  <span>Total</span>
                </div>

                <div>
                  <span>{venda.totalFormatted}</span>
                </div>
              </div>
            </div>
          </Total>
        </OrderContent>
      </Content>
    </Container>
  );
};

export default ModalVenda;
